import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface ProductDescriptionProps {
  productDescriptions: { ar: string; en: string };
  onDescriptionChange: (lang: "ar" | "en", value: string) => void;
}

function ProductDescription({
  productDescriptions,
  onDescriptionChange,
}: ProductDescriptionProps) {
    const { t,i18n } = useTranslation();
  const locale = i18n.language
  const initialInputValue = locale === "ar" ? "ar": "en" 
  const [productDescriptionLang, setProductDescriptionLang] = useState<"ar" | "en">(initialInputValue);

  const handleProductDescriptionChange =
    (lang: "ar" | "en") => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onDescriptionChange(lang, e.target.value);
    };

  const handleDescriptionLangChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setProductDescriptionLang(e.target.value as "ar" | "en");
  };

  return (
    <div className="relative flex w-full items-start justify-start overflow-hidden rounded-sm border border-gray-200 p-2">
      {/* Arabic Textarea */}
      <div className={`h-full ${productDescriptionLang === "ar" ? "block w-full" : "hidden"}`}>
        <textarea
          name="productDescriptionAr"
          id="productDescriptionAr"
          className="h-24 w-full resize-none rounded-sm px-2 pe-[3.5rem]"
          placeholder={t("product.description.placeholder.ar")}
          value={productDescriptions.ar}
          onChange={handleProductDescriptionChange("ar")}
        />
      </div>

      {/* English Textarea */}
      <div className={`h-full ${productDescriptionLang === "en" ? "block w-full" : "hidden"}`}>
        <textarea
          name="productDescriptionEn"
          id="productDescriptionEn"
          className="h-24 w-full resize-none rounded-sm px-2 pe-[3.5rem]"
          placeholder={t("product.description.placeholder.en")}
          value={productDescriptions.en}
          onChange={handleProductDescriptionChange("en")}
        />
      </div>

      {/* Language Selector */}
      <select
        className="absolute end-0 top-0 h-8 w-[3.5rem] rounded-sm"
        name="productDescription-lang"
        value={productDescriptionLang}
        onChange={handleDescriptionLangChange}
      >
        <option value="ar">AR</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
}

export default ProductDescription;
